import { Icon, List, ListItem, Navbar, Page } from "framework7-react";

import { NavLeftBack } from "@/components/NavLeftBack";
import { NavRightEmpty } from "@/components/NavRightEmpty";
import { NavTitle } from "@/components/NavTitle";
import { createPage, PageComponentProps } from "@/factories/createPage";
import { useSignOut } from "@/generated/api";
import { usePageReady } from "@/hooks/usePageReady";
import { useAuthStore } from "@/stores/authStore";

export const AccountSettingPage = createPage("AccountSettingPage", PageComponent);

function PageComponent({ pageName }: PageComponentProps) {
  const { getPageProps } = usePageReady(pageName);
  const { clear } = useAuthStore();

  const { mutate: signOut } = useSignOut({
    mutation: {
      onSuccess: () => {
        clear();
      },
    },
  });

  return (
    <Page
      data-component={pageName}
      {...getPageProps()}
    >
      <Navbar>
        <NavLeftBack />
        <NavTitle>アカウント</NavTitle>
        <NavRightEmpty />
      </Navbar>

      <List
        dividersIos
        inset
        mediaList
        strong
      >
        <ListItem
          chevronCenter
          link="/settings/account/email"
          title="メールアドレス確認・変更"
        >
          <Icon
            material="mail"
            slot="media"
          />
        </ListItem>

        <ListItem
          chevronCenter
          link="/settings/account/password"
          title="パスワード変更"
        >
          <Icon
            material="lock"
            slot="media"
          />
        </ListItem>

        <ListItem
          chevronCenter
          link="#"
          title="ログアウト"
          onClick={() => signOut()}
        >
          <Icon
            material="logout"
            slot="media"
          />
        </ListItem>
      </List>
    </Page>
  );
}
